import { Button, Divider, Flex, Modal, Skeleton } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Plan } from 'modules/main/auth/register/models/plans';
import { onChoosePlan, onGetPlans } from 'core/services/plans';
import NotificationService from 'core/services/notification';
import PlanComponent from 'components/plan/plan';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import Icon from 'utils/icon';
import { onGetCustomerSupport } from 'modules/main/dashboard/services/dashboardService';
import { AccountManager } from 'modules/main/dashboard/models/AccountStatus';

import styles from '../../layout.module.scss';

interface ContactModalComponentProps {
	open: boolean;
	onClose: () => void;
}

const ContactModalComponent: FunctionComponent<ContactModalComponentProps> = ({ open, onClose }) => {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(true);
	const [accountManager, setAccountManager] = useState<AccountManager>();

	useEffect(() => {
		if (open) {
			getAccountManagerHandler();
		}
	}, [open]);

	const onCloseHandler = () => {
		onClose();
	};

	const getAccountManagerHandler = async () => {
		try {
			setIsLoading(true);
			const response = await onGetCustomerSupport();
			setAccountManager(response);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.FETCH_ERROR'));
		}
	};

	return (
		<Modal open={open} onCancel={onCloseHandler} title={null} footer={null} width={600}>
			<div>
					<Icon name="hefthLogo" width={60} height={40} />
				<h6 className="fw-medium mt-2 mb-3">{t('COMMON.TO_CHARGE')}</h6>
				<div className={styles.accountManager}>
					<div className={styles.accountManager_header}>
						<Icon name="accountManager" width={40} height={40} />
						<div>
							<h6 className="fw-medium">{t('DASHBOARD.ACCOUNT_MANAGER_NAME')}</h6>
							{isLoading ? <Skeleton.Input style={{ width: 150, height: 22 }} active /> : <p>{accountManager?.name ?? t('COMMON.N_A')}</p>}
						</div>
					</div>

					<div className={styles.accountManager_body}>
						<div>
							<h6 className="fw-medium">{t('COMMON.EMAIL')}</h6>
							{isLoading ? (
								<Skeleton.Input style={{ width: 150, height: 22 }} active />
							) : (
								<p className="mb-0">{accountManager?.email ?? t('COMMON.N_A')}</p>
							)}
						</div>

						<Divider />

						<div>
							<h6 className="fw-medium">{t('COMMON.PHONE_NUMBER')}</h6>
							{isLoading ? (
								<Skeleton.Input style={{ width: 150, height: 22 }} active />
							) : (
								<p className="mb-0">{accountManager?.phone ?? t('COMMON.N_A')}</p>
							)}
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default ContactModalComponent;
